import type { ApiAddress } from '#/api/types/ApiAddress';
import { H4 } from '#/components/Text/H4';

type Props = {
  address: ApiAddress;
};

export function Address({ address }: Props) {
  return (
    <>
      {address.description && (
        <H4 style={{ marginBottom: 0 }}>{address.description}</H4>
      )}

      <div>
        {address.full}
        {address.line2 && <br />}
        {address.line2}
      </div>
    </>
  );
}
